import { ROTATE_ELEMENT } from "../../actions";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case ROTATE_ELEMENT:
      var rotateDirection = action.payload.direction;
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          return {
            ...old_layer,
            text_elements: old_layer.text_elements.map((textElement) => {
              if (textElement.is_selected) {
                if (rotateDirection === "right") {
                  return {
                    ...textElement,
                    rotation:
                      textElement.rotation >= 355 ? 0 : textElement.rotation + 5
                  };
                } else {
                  return {
                    ...textElement,
                    rotation:
                      textElement.rotation <= 0 ? 355 : textElement.rotation - 5
                  };
                }
              } else {
                return textElement;
              }
            }),
            image_elements: old_layer.image_elements.map((imageElement) => {
              if (imageElement.is_selected) {
                if (rotateDirection === "right") {
                  return {
                    ...imageElement,
                    rotation:
                      imageElement.rotation >= 355
                        ? 0
                        : imageElement.rotation + 5
                  };
                } else {
                  return {
                    ...imageElement,
                    rotation:
                      imageElement.rotation <= 0
                        ? 355
                        : imageElement.rotation - 5
                  };
                }
              } else {
                return imageElement;
              }
            })
          };
        })
      };

    default:
      return state;
  }
}
